import { useEffect } from 'react';

function useApplyCenterOfRotation(rendererRef, getInteractorStyle, autoCenterOfRotation) {
    // This runs every react render, since I'm not sure what deps would
    // trigger whenever the underlying renderer changes.
    useEffect(() => {
        const ren = rendererRef.current;
        if (!ren)
            return;
        const sub = ren.get().onEvent((ev) => {
            const rendererEvent = ev;
            if (rendererEvent.type === 'ResetCameraEvent') {
                const style = getInteractorStyle();
                if (!autoCenterOfRotation || !style.setCenterOfRotation) {
                    return;
                }
                const center = rendererEvent.renderer.getActiveCamera().getFocalPoint();
                style.setCenterOfRotation(center);
            }
        });
        return () => {
            sub.unsubscribe();
        };
    });
}

export { useApplyCenterOfRotation as default };
